export const deliveryReportDefaultGridState = {
	"sideBar": {
		"visible": true,
		"position": "right",
		"openToolPanel": null,
		"toolPanels": {
		}
	},
	"columnVisibility": {
		"hiddenColIds": []
	},
	"columnSizing": {
		"columnSizingModel": [
			{ "colId": "alternate_reference", "width": 150},
			{ "colId": "week_no", "width": 120},
            { "colId": "load_start", "width": 175},
            { "colId": "load_start_time", "width": 150},
            { "colId": "load_end", "width": 175},
            { "colId": "load_end_time", "width": 150},
            { "colId": "local_time", "width": 150},
            { "colId": "time_zone_id", "width": 150},
            { "colId": "trip_number", "width": 175},
            { "colId": "lading_number", "width": 200},
            { "colId": "pool_id", "width": 125},
            { "colId": "lading_status", "width": 150},
            { "colId": "no_of_pallets", "width": 150},
            { "colId": "pallet_delivered", "width": 150},
            { "colId": "no_of_cartons", "width": 120},
            { "colId": "no_of_cartons_delivered", "width": 170},
            { "colId": "barcode_reader_scanned", "width": 200},
            { "colId": "manual_checks", "width": 150},
			{ "colId": "auto_check_delivered", "width": 175},
			{ "colId": "consignee_name", "width": 200},
			{ "colId": "consignee_locality", "width": 150},
			{ "colId": "shipper_name", "width": 150},
			{ "colId": "carrier_name", "width": 175},
			{ "colId": "customer_name", "width": 175},
			{ "colId": "created", "width": 180}
		]
	},
	"columnOrder": {
		"orderedColIds": [
			"alternate_reference",
			"week_no",
			"load_start",
			"load_start_time",
			"load_end",
			"load_end_time",
			"local_time",
			"time_zone_id",
			"trip_number",
			"lading_number",
			"pool_id",
			"lading_status",
			"no_of_pallets",
			"pallet_delivered",
			"no_of_cartons",
			"no_of_cartons_delivered",
			"barcode_reader_scanned",
			"manual_checks",
			"auto_check_delivered",
			"consignee_name",
			"consignee_locality",
			"shipper_name",
			"carrier_name",
			"customer_name",
			"created"
		]
	}
}